module.exports = __webpack_public_path__ + "img/expertise4.6322ddb3.png";